import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function Leadership() {
  return (
    <>
      <Navbar2 />
      <div className="container-fluid pt-3">
        <div className="row text-center">
          <div className="col pt-3 ps-5 pe-5">
            <div className="h1">
              LEADERSHIP
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid pt-3 pb-4">
        <div className="row row-cols-1 row-cols-md-3 row-col-lg-4 g-4">
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  <img src="./s3/tim_porter.png"
                    className="img-fluid rounded-start"
                    alt=""
                  />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">Tim Porter</h5>
                    <p className="card-text">Founder & CEO</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  <img src="./s3/courtni_g.png"
                    className="img-fluid rounded-start"
                    alt=""
                  />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">Courtni Gaston</h5>
                    <p className="card-text">VP of Operations</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  <img src="./s3/anthony_o.png"
                    className="img-fluid rounded-start"
                    alt=""
                  />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">Anthony Ortega</h5>
                    <p className="card-text">Chief Information Officer</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  {/* <img src="./s3/tim_porter.png"
                    className="img-fluid rounded-start"
                    alt=""
                  /> */}
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">John Hollmon</h5>
                    <p className="card-text">Director of Basketball and Player Development</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  <img src="./s3/patricia_a.png"
                    className="img-fluid rounded-start"
                    alt=""
                  />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">Patricia Altamirano</h5>
                    <p className="card-text">Director of Sports Operations</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  <img src="./s3/sarah_o.jpg"
                    className="img-fluid rounded-start"
                    alt=""
                  />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">Sarah O'Neal</h5>
                    <p className="card-text">Player Development Coordinator</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  <img src="./s3/priscilla_p.png"
                    className="img-fluid rounded-start"
                    alt=""
                  />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">Priscilla Perez</h5>
                    <p className="card-text">Social Media & Marketing</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card mb-3">
              <div className="row g-0">
                <div className="col-md-4">
                  {/* <img src="./s3/priscilla_p.png"
                    className="img-fluid rounded-start"
                    alt=""
                  /> */}
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title">Albert Rodriguez</h5>
                    <p className="card-text">Social Media & Marketing</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Leadership;
